// Vuex user module mutations types
export const FILL_LIST = 'FILL_LIST';
export const FILL_AGENTS = 'FILL_AGENTS';
export const SET_CALLING_AGENT_DETAILS = 'SET_CALLING_AGENT_DETAILS';
